import * as React from 'react';
import { useNavigate } from 'react-router';
import { useGetAdminTenants } from '@/__generated__/admin/admin';
import { DataTable, Column } from '@/features/pagination/components/DataTable';
import { usePagination } from '@/features/pagination/hooks/usePagination';
import { formatDate } from '@/utils/date';
import { Tenant } from '@/__generated__/model/tenant';
import { InviteYourselfAsTenantUserDialog } from './InviteYourselfAsTenantUserDialog';
import { CreateTenantDialog } from './CreateTenantDialog';
import { Button } from '@/components/ui/button';

export function ListTenantsPage() {
  const navigate = useNavigate();
  const { page, perPage, handlePageChange } = usePagination();

  const { data, isLoading, mutate } = useGetAdminTenants({
    page,
    per_page: perPage,
  });

  const tenants = data?.tenants ?? ([] as Tenant[]);
  const hasNextPage = tenants.length === perPage;
  const hasPreviousPage = page > 1;

  const columns: Column<Tenant>[] = [
    {
      header: 'ID',
      accessor: 'id',
    },
    {
      header: 'サブドメイン',
      accessor: 'subdomain',
    },
    {
      header: '表示名',
      accessor: 'display_name',
    },
    {
      header: '作成日',
      accessor: 'created_at',
      cell: (row: Tenant) => formatDate(row.created_at),
    },
    {
      header: '更新日',
      accessor: 'updated_at',
      cell: (row: Tenant) => formatDate(row.updated_at),
    },
    {
      header: '',
      accessor: 'id',
      cell: (row: Tenant) => (
        <div className="flex flex-col gap-2">
          <Button variant="outline" onClick={() => navigate(`/tenants/${row.id}/projects`)}>
            プロジェクト一覧
          </Button>
          <InviteYourselfAsTenantUserDialog tenantId={row.id} tenantName={row.display_name} />
        </div>
      ),
    },
  ];

  return (
    <div className="space-y-6 px-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-900">テナント一覧</h1>
        <CreateTenantDialog onSuccess={mutate} />
      </div>
      <DataTable
        data={tenants}
        columns={columns}
        page={page}
        hasNextPage={hasNextPage}
        hasPreviousPage={hasPreviousPage}
        onPageChange={handlePageChange}
        isLoading={isLoading}
      />
    </div>
  );
}
